export const EVENT_PARTNER_CREATE_REQUEST = 'EVENT_PARTNER_CREATE_REQUEST';

export const EVENT_PARTNER_UPDATE_REQUEST = 'EVENT_PARTNER_UPDATE_REQUEST';

export const EVENT_PARTNER_LIST_REQUEST = 'EVENT_PARTNER_LIST_REQUEST';

export const EVENT_PARTNER_DETAILS_REQUEST = 'EVENT_PARTNER_DETAILS_REQUEST';

export const EVENT_PARTNER_REWARD_LIST_REQUEST = 'EVENT_PARTNER_REWARD_LIST_REQUEST';
